const menuToggle = document.querySelector('[data-menu-toggle]');
const menuPanels = Array.from(document.querySelectorAll('[data-menu-panel]'));

if (menuToggle && menuPanels.length) {
  menuToggle.addEventListener('click', () => {
    menuPanels.forEach((panel) => panel.classList.toggle('is-open'));
  });
}

const langSelect = document.querySelector('[data-lang-select]');
if (langSelect) {
  langSelect.addEventListener('change', (event) => {
    const target = event.target;
    if (!target || !target.value) return;
    window.location.href = target.value;
  });
}

const themeToggle = document.querySelector('[data-theme-toggle]');
const storedTheme = localStorage.getItem('theme');

if (storedTheme) {
  document.documentElement.setAttribute('data-theme', storedTheme);
}

if (themeToggle) {
  const isDarkInitial = document.documentElement.getAttribute('data-theme') === 'dark';
  themeToggle.setAttribute('aria-pressed', String(isDarkInitial));
  themeToggle.addEventListener('click', () => {
    const isDark = document.documentElement.getAttribute('data-theme') === 'dark';
    const nextTheme = isDark ? 'light' : 'dark';
    document.documentElement.setAttribute('data-theme', nextTheme);
    themeToggle.setAttribute('aria-pressed', String(nextTheme === 'dark'));
    localStorage.setItem('theme', nextTheme);
  });
}
